<template>
  <div class="user-content">
    <div class="user-view">
      <div class="user-info-menu">
        <el-menu
          :default-active="activeMenu"
          :default-openeds="openeds"
          :collapse="false"
          class="el-menu-vertical-demo"
        >
          <el-submenu index="/user/center/view/info">
            <template slot="title">
              <i class="el-icon-location"></i>
              <span>企业信息</span>
            </template>
            <el-menu-item index="/user/center/view/info">
              <template slot="title">
                <router-link to="/user/center/view/info">
                  基本信息
                </router-link>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/center/view/innovate">
              <template slot="title">
                <router-link to="/user/center/view/innovate">
                  研发创新
                </router-link>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/center/view/field">
              <template slot="title">
                <router-link to="/user/center/view/field">
                  厂房场地
                </router-link>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/center/view/resources">
              <template slot="title">
                <router-link to="/user/center/view/resources">
                  人力资源
                </router-link>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/center/view/financing">
              <template slot="title">
                <router-link to="/user/center/view/financing">
                  融资上市
                </router-link>
              </template>
            </el-menu-item>
            <el-menu-item index="/user/center/view/produce">
              <template slot="title">
                <router-link to="/user/center/view/produce">
                  生产经营
                </router-link>
              </template>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="/user/center/view/safe">
            <template slot="title">
              <router-link to="/user/center/view/safe">
                <i class="el-icon-setting"></i>
                账户安全
              </router-link>
            </template>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="routerView">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      openeds: [
        "/user/center/view/info",
        "/user/center/view/innovate",
        "/user/center/view/field",
        "/user/center/view/resources",
        "/user/center/view/financing",
        "/user/center/view/produce"
      ]
    };
  },
  computed: {
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    }
  }
};
</script>
<style lang="less" scoped>
.user-content {
  width: 100%;
}
.user-view {
  width: 100%;
  min-height: 580px;
  padding: 50px 30px;
  background: #fff;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  & .routerView {
    width: 0;
    flex: 1;
    margin-left: 50px;
  }
  .routerLink {
    padding: 20px;
    display: flex;
    a {
      text-align: center;
      width: 88px;
      height: 35px;
      line-height: 35px;
      color: #312f2f;
      margin-right: 8px;
      &.router-link-active {
        background: #1d6cea;
        border-radius: 6px;
        color: #fff;
      }
    }
  }
}
.user-info-menu {
  width: 240px;
  color: RGBA(76, 128, 231, 1);
  .el-menu {
    .el-menu-item {
      padding: 0px;
      a {
        display: flex;
        align-items: center;
      }
    }
    .el-menu-item.is-active {
      background-color: RGBA(76, 128, 231, 1);
      color: #fff;
    }
  }
  .el-menu-vertical-demo {
    border: 1px solid rgba(230, 232, 240, 1);
  }
}
</style>
